import { render } from "./AddAddressModal.vue?vue&type=template&id=1f9745aa&scoped=true&ts=true"
import script from "./AddAddressModal.vue?vue&type=script&lang=ts"
export * from "./AddAddressModal.vue?vue&type=script&lang=ts"

import "./AddAddressModal.vue?vue&type=style&index=0&id=1f9745aa&lang=scss&scoped=true"
import "./AddAddressModal.vue?vue&type=style&index=1&id=1f9745aa&lang=scss&scoped=true"
import "./AddAddressModal.vue?vue&type=style&index=2&id=1f9745aa&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9745aa"]])

export default __exports__